import {Model} from "@/store/models/model";
import axios from "@/store/vue-axios";

export class VserverNetworks extends Model {

  static entity = 'vserver_networks'
  static primaryKey = 'id'
  static apiEntity = 'networks'

  static fields() {
    return {
      id: this.attr(null),
      vserver_id: this.attr(null),
      mac_address: this.attr(null),
      netname: this.attr(null),
      user: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
    }
  }
  static async getNetworks(vid){
    const x = axios.get("/datacenter/vservers/"+vid+"/networks").then(res=>{
      console.log('NETWORKS RES:::',res)
    })
      .catch(err=>{console.log(err)})
  }
}

export default VserverNetworks



// WEBPACK FOOTER //
// ./src/store/models/vserver/vserver_networks.js